import { render, staticRenderFns } from "./PolicyPDF.vue?vue&type=template&id=ddd4ba04&scoped=true&"
import script from "./PolicyPDF.vue?vue&type=script&lang=js&"
export * from "./PolicyPDF.vue?vue&type=script&lang=js&"
import style0 from "./PolicyPDF.vue?vue&type=style&index=0&id=ddd4ba04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd4ba04",
  null
  
)

export default component.exports